var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .75A.75.75 0 0 1 .75 0h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 0 .75",
    clipRule: "evenodd"
  })));
};
export default SvgMinus;